<template>
  <button class="fct-button" :class="b_class" tabindex="-1" type="button">
    <slot></slot>
  </button>
</template>
<script>
  export default {
    props: ['b_class']
  }
</script>
<style scoped>
  button.fct-button {
    margin: 0;
    padding-right: 0;
    padding-left: 0;
  }
</style>
